import { render, staticRenderFns } from "./dataIntroduce.vue?vue&type=template&id=bee2207a&scoped=true&"
import script from "./dataIntroduce.vue?vue&type=script&lang=js&"
export * from "./dataIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./dataIntroduce.vue?vue&type=style&index=0&id=bee2207a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee2207a",
  null
  
)

export default component.exports